import { TextInput } from '@odekoteam/doppio';
import SearchSvg from 'assets/svgs/search.svg';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePickerDropdown from 'src/components/DatePicker';
import LoggedInContainer from 'src/components/LoggedInContainer';
import { loginPath } from 'src/components/Navbar';
import RouteLoadError from 'src/components/RouteLoadError';
import ItemsTable from 'src/components/SearchItems/ItemsTable';
import WarehouseDropdown from 'src/components/WarehouseDropdown';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import analytics from 'src/services/analytics';
import { authSelector } from 'src/state/selectors/auth';
import {
  nightEndSelector,
  routesLoadingSelector,
  routesSelector,
  selectedWarehouseIdSelector,
} from 'src/state/selectors/delivery';
import { getRoutes } from 'src/state/slices/delivery';
import { clearRouteQuantities } from 'src/state/slices/fulfillmentDeltas';
import { Flex } from 'theme-ui';
import { headerWrapper, pageContainer } from '../styles';

const ItemSearch = (): JSX.Element => {
  const navigate = useNavigate();
  const { isUserAuthenticated } = useAppSelector(authSelector);
  const dispatch = useAppDispatch();
  const routes = useAppSelector(routesSelector);
  const routesLoading = useAppSelector(routesLoadingSelector);
  const routesError = useAppSelector((state) => state.delivery.routesError);
  const nightEnd = useAppSelector(nightEndSelector);
  const selectedWarehouseId = useAppSelector(selectedWarehouseIdSelector);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    analytics.track(`"Issues" Page Visit`);
  }, []);

  useEffect(() => {
    if (!isUserAuthenticated) {
      navigate(loginPath);
    }
  }, [isUserAuthenticated, navigate]);

  useEffect(() => {
    dispatch(clearRouteQuantities());
  }, [dispatch, selectedWarehouseId, nightEnd.viewing]);

  useEffect(() => {
    if (
      !routes &&
      !routesLoading &&
      !routesError &&
      selectedWarehouseId &&
      nightEnd.viewing
    ) {
      dispatch(
        getRoutes({
          warehouseId: selectedWarehouseId,
          nightEnd: nightEnd.viewing,
        }),
      );
    }
  }, [
    dispatch,
    routes,
    routesLoading,
    routesError,
    selectedWarehouseId,
    nightEnd.viewing,
  ]);

  return (
    <LoggedInContainer style={{ height: '100vh' }}>
      <Flex id="itemSearch" sx={{ ...pageContainer, overflowY: 'auto' }}>
        <div
          id="itemSearchHeader"
          sx={{ ...headerWrapper, flexDirection: ['column', 'row'] }}
        >
          <WarehouseDropdown />
          <DatePickerDropdown style={{ alignSelf: 'center' }} />
        </div>
        <RouteLoadError />
        {(routesLoading || (!routes && !routesError)) && (
          <Flex sx={{ fontFamily: 'body', justifyContent: 'center' }}>
            Loading...
          </Flex>
        )}
        {routes && (
          <>
            <Flex
              sx={{
                justifyContent: 'space-between',
                width: '100%',
                margin: '10px 0px 12px 10px',
              }}
            >
              <TextInput
                iconLeft={<SearchSvg />}
                id="item-search"
                onChangeText={(value): void => setSearchValue(value)}
                placeholder="Search"
                value={searchValue}
              />
            </Flex>
            <ItemsTable routes={routes} searchValue={searchValue} />
          </>
        )}
      </Flex>
    </LoggedInContainer>
  );
};

export default ItemSearch;
